// extracted by mini-css-extract-plugin
module.exports = {"default":"button_default__2xYmv"};